import { render, staticRenderFns } from "./Gender.vue?vue&type=template&id=5960748e"
import script from "./Gender.vue?vue&type=script&lang=js"
export * from "./Gender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports